
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/specjalisci-bluetooth-low-energy",
      function () {
        return require("private-next-pages/specjalisci-bluetooth-low-energy.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/specjalisci-bluetooth-low-energy"])
      });
    }
  